import type { BetterAuthClientPlugin } from 'better-auth/client';
import type { telegramAuthPlugin } from '../server';

export const telegramAuthClientPlugin = () => {
    return {
        id: 'telegramAuth',
        $InferServerPlugin: {} as ReturnType<typeof telegramAuthPlugin>,
    } satisfies BetterAuthClientPlugin;
};
